import { SearchGroup } from '@components/input';
import { IFilterSelectItems } from '@redux/slices/order';
import { Col, Row } from 'antd';
import React, { memo, useContext } from 'react';
import { ExportButton } from '@styles/components/button';
import { useDispatch, useSelector } from 'react-redux';
import item, { exportItems, fetchItems, itemSelector, setSearch } from '@redux/slices/item';
import { ModalContext } from 'src/contexts/modal-context';
import { EditModal } from './edit-modal';
import { translate } from '@components/i18n';
import { Option, Select } from '@styles/components/form';
import { filterStatus } from '../constants';
import { ITEM_STATUS } from 'src/enums/item-status';
import { cleanObject } from '@utils/objects';

export const Header: React.FC = memo(() => {
    const dispatch = useDispatch();
    const modalContext = useContext(ModalContext);
    const itemData = useSelector(itemSelector);

    const filter = (filter: Partial<IFilterSelectItems>): void => {
        const params = {
            query: itemData.search.query,
            status: itemData.search.status,
        }

        if ("status" in filter) {
            dispatch(setSearch({
                query: itemData.search.query,
                status: filter.status,
            }));
            params.status = filter.status;
        } else if ("filterValue" in filter) {
            dispatch(setSearch({
                query: filter.filterValue,
                status: itemData.search.status,
            }));
            params.query = filter.filterValue
        }

        dispatch(fetchItems({
            current: 1,
            pageSize: 10,
            query: params.query || "",
            status: params.status || undefined
        }));
    };

    const add = (): void => {
        modalContext.setIsOpen(true, <EditModal />, {
            title: translate('general.registerItem'),
            width: '40%',
        });
    };

    const onExport = (): void => {
        const params = {
            query: itemData?.search.query || '',
            status: itemData?.search.status || '',
        }
        dispatch(exportItems(cleanObject(params)));
    };


    return (
        <Col>
            <Row style={{ marginTop: 20 }} align="middle">
                <Col span={24}>
                    <Row justify={'space-between'} align="middle">
                        <Col span={5}>
                            <label>Buscar:</label>
                            <SearchGroup
                                allowClear
                                placeholder={translate(
                                    'forms.placeholders.search',
                                )}
                                onSearch={(e) => {
                                    filter({ filterValue: e });
                                }}
                                width='95%'
                            />
                        </Col>
                        <Col span={5}>
                            <label>Status:</label>
                            <br />
                            <Select
                                placeholder={translate('general.all')}
                                dropdownMatchSelectWidth={false}
                                allowClear
                                onChange={(value) => {
                                    filter({ status: value as ITEM_STATUS });
                                }}
                            >
                                {filterStatus.map((c) => (
                                    <Option value={c.name}>
                                        {c.description}
                                    </Option>
                                ))}
                            </Select>
                        </Col>
                        <Col span={14}>
                            <Row justify={'end'}>
                                <Col style={{ marginRight: 10, display: 'flex', gap: 4 }}>
                                    <ExportButton onClick={add}>
                                        {translate('forms.buttons.addNew')}
                                    </ExportButton>
                                    <ExportButton onClick={onExport}>
                                        {translate('general.export')}
                                    </ExportButton>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Col>
    );
});
